import type { SVGProps } from 'react'

export const ThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3751 25.8268H13.0718C12.5568 25.8268 12.1401 25.4102 12.1401 24.8952V17.5918C12.1401 17.0768 12.5568 16.6602 13.0718 16.6602H15.3751C15.8901 16.6602 16.3068 17.0768 16.3068 17.6618V24.9652C16.3068 25.4085 15.8901 25.8268 15.3751 25.8268Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3068 23.8508L18.1102 25.3458C18.4835 25.6558 18.9552 25.8258 19.4402 25.8258H25.4118C26.1602 25.8258 26.8185 25.3291 27.0252 24.6091L28.2452 20.3391C28.4302 19.6941 28.3218 18.9991 27.9502 18.4408C27.5302 17.8091 26.8252 17.4308 26.0702 17.4308H25.0368H23.2952L23.3035 14.5941C23.3102 12.4858 20.5418 11.7025 19.4418 13.5008L16.3052 18.6358"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0117 5.45111L23.4284 4.26944C24.5434 3.72444 25.8917 4.16111 26.4734 5.25944L27.735 7.63611C28.0684 8.26278 28.6717 8.70111 29.3717 8.82444L32.0217 9.28944C33.245 9.50444 34.0767 10.6494 33.9034 11.8794L33.5267 14.5428C33.4267 15.2461 33.6584 15.9561 34.1517 16.4661L36.0217 18.3994C36.885 19.2911 36.885 20.7078 36.0217 21.6011L34.1517 23.5344C33.6584 24.0444 33.4267 24.7544 33.5267 25.4578L33.9034 28.1211C34.0767 29.3511 33.245 30.4961 32.0217 30.7111L29.3717 31.1761C28.6717 31.2994 28.0684 31.7378 27.735 32.3644L26.4734 34.7411C25.8917 35.8378 24.545 36.2761 23.4284 35.7311L21.0117 34.5494C20.3734 34.2378 19.6284 34.2378 18.99 34.5494L16.5734 35.7311C15.4584 36.2761 14.11 35.8394 13.5284 34.7411L12.2667 32.3628C11.9334 31.7361 11.33 31.2978 10.63 31.1744L7.98002 30.7094C6.75669 30.4944 5.92502 29.3494 6.09835 28.1194L6.47502 25.4561C6.57502 24.7528 6.34335 24.0428 5.85002 23.5328L3.98002 21.5994C3.11669 20.7078 3.11669 19.2911 3.98002 18.3978L5.85002 16.4644C6.34335 15.9544 6.57502 15.2444 6.47502 14.5411L6.10002 11.8778C5.92502 10.6494 6.75835 9.50277 7.98169 9.28944L10.6317 8.82444C11.33 8.70111 11.9334 8.26278 12.2667 7.63611L13.5284 5.25944C14.11 4.16278 15.4567 3.72444 16.5734 4.26944L18.99 5.45111C19.6267 5.76278 20.3734 5.76278 21.0117 5.45111Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
